import mutations from './mutations';
import getters from './getters';
import actions from './actions';

export default {
  namespaced: true,
  state: {
    infoMessages: [],
    totalCount: 0,
  },
  actions,
  getters,
  mutations,
};
